import { render, staticRenderFns } from "./UserInfoBase.vue?vue&type=template&id=68eb67f6&scoped=true&"
import script from "./UserInfoBase.vue?vue&type=script&lang=ts&"
export * from "./UserInfoBase.vue?vue&type=script&lang=ts&"
import style0 from "./UserInfoBase.vue?vue&type=style&index=0&id=68eb67f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68eb67f6",
  null
  
)

export default component.exports